"use client"

export const VisaHero = () => {
  return (
    <section className="relative bg-white border-b-8 border-orange-500 pt-24 animate-in fade-in duration-700">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="text-center border-b-4 border-gray-900 pb-8 mb-10">
          <div className="text-sm text-gray-600 mb-3 tracking-widest uppercase">
            Travel Warehouse Inc. • Visa Services
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 tracking-tight">Visa Assistance</h1>
          <div className="text-xl md:text-2xl text-gray-700 mt-4 italic">Making Complex Processes Simple</div>
        </div>

        <div className="grid md:grid-cols-2 gap-10">
          <div className="border-l-4 border-orange-500 pl-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-6">
              Complete Visa Requirements and Processing Information
            </h2>
            <p className="text-lg md:text-xl leading-relaxed text-gray-700 mb-6">
              <span className="font-bold text-2xl float-left mr-0.5 leading-none text-amber-600">N</span>
              avigating visa requirements can be overwhelming, but we're here to make it straightforward. Our
              comprehensive visa assistance service provides you with all the information and support you need for your
              travel destinations.
            </p>
            <p className="text-base md:text-lg leading-relaxed text-gray-600">
              From document preparation to application submission, we guide you through every step of the visa process,
              ensuring you have everything you need for a successful application.
            </p>
          </div>

          <div className="flex items-center justify-center">
            <div className="overflow-hidden rounded-2xl shadow-xl">
              <img
                src="/PASAPORTE.jpg"
                alt="Travel and Visa Services"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
